import * as THREE from 'three'

export interface Object3DResourceCount {
  geometries: number
  materials: number
}

const collectObject3DResources = (obj: THREE.Object3D): { geometries: Set<THREE.BufferGeometry>; materials: Set<THREE.Material> } => {
  const geometries = new Set<THREE.BufferGeometry>()
  const materials = new Set<THREE.Material>()

  obj.traverse((child) => {
    if (
      child instanceof THREE.Mesh ||
      child instanceof THREE.LineSegments ||
      child instanceof THREE.Line
    ) {
      const geometry = child.geometry as THREE.BufferGeometry | undefined
      if (geometry) {
        geometries.add(geometry)
      }

      const rawMaterial = child.material as THREE.Material | THREE.Material[] | undefined
      if (rawMaterial) {
        const materialList = Array.isArray(rawMaterial) ? rawMaterial : [rawMaterial]
        materialList.forEach((material) => materials.add(material))
      }
    }
  })

  return { geometries, materials }
}

export function countObject3DResources(obj: THREE.Object3D): Object3DResourceCount {
  const collected = collectObject3DResources(obj)
  return {
    geometries: collected.geometries.size,
    materials: collected.materials.size,
  }
}

export function countAndDisposeObject3D(obj: THREE.Object3D): Object3DResourceCount {
  const collected = collectObject3DResources(obj)
  collected.geometries.forEach((geometry) => geometry.dispose())
  collected.materials.forEach((material) => material.dispose())
  return {
    geometries: collected.geometries.size,
    materials: collected.materials.size,
  }
}
